<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-search-table`]" width="1em" height="1em" v-bind="$attrs"><path d="M14.6267 18.2361C13.601 17.2104 13.601 15.5474 14.6267 14.5217C15.6524 13.4961 17.3153 13.4961 18.341 14.5217L21.8207 18.0014C22.8464 19.0271 22.8464 20.6901 21.8207 21.7157C20.795 22.7414 19.1321 22.7414 18.1064 21.7157L14.6267 18.2361Z" :fill="useCurrentColor ? 'currentColor' : '#165DFF'"/><rect x="1.5" y="1.5" width="18.416" height="18.416" rx="9.208" :fill="useCurrentColor ? 'currentColor' : '#BEDAFF'"/></svg>
</template>
<script>

export default {
  name: 'IconColorSearchTable',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
